import AdminPropertiesEditForm from "../../../components/Admin/AdminPropertiesEditForm/AdminPropertiesEditForm";

type Props = {};

const AdminEditPropertiesPage = (props: Props) => {
  return <AdminPropertiesEditForm />;
};

export default AdminEditPropertiesPage;
